import { render } from "./IntroVideo.vue?vue&type=template&id=910ca844&scoped=true"
import script from "./IntroVideo.vue?vue&type=script&lang=js"
export * from "./IntroVideo.vue?vue&type=script&lang=js"

import "./IntroVideo.vue?vue&type=style&index=0&id=910ca844&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910ca844"]])

export default __exports__